import React from 'react';
import { Alert, Form } from 'react-bootstrap';
import { CONFIG_FIELD_LABELS } from './configFormValidators';

export const ConfigReadOnlyBanner = () => (
  <Alert variant="info" className="mb-3">
    You are viewing this page in read-only mode.
  </Alert>
);

export const ConfigFormLabel = ({ label, fieldName, sensitiveFields = [], htmlFor, className }) => (
  <Form.Label htmlFor={htmlFor} className={className}>
    {label}
    {sensitiveFields.includes(fieldName) && (
      <span
        className="badge badge-warning ml-2"
        style={{ fontSize: '0.7em', verticalAlign: 'middle' }}
      >
        Sensitive
      </span>
    )}
  </Form.Label>
);

export const ConfigFormSwitch = ({
  label,
  fieldName,
  checked,
  onChange,
  id,
  disabled = false,
  sensitiveFields = [],
}) => (
  <Form.Group>
    <div className="d-flex align-items-center">
      <Form.Check
        type="switch"
        id={id}
        label={label}
        name={fieldName}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {sensitiveFields.includes(fieldName) && (
        <span className="badge badge-warning ml-2" style={{ fontSize: '0.7em' }}>
          Sensitive
        </span>
      )}
    </div>
  </Form.Group>
);

export const SensitiveFieldsConfirmationBody = ({ changedFields }) => {
  const labels = changedFields.map((field) => CONFIG_FIELD_LABELS[field] || field);
  return (
    <>
      <p>You have modified the following sensitive fields:</p>
      <ul>
        {labels.map((label) => (
          <li key={label}>{label}</li>
        ))}
      </ul>
      <p className="mb-0">Are you sure you want to save these changes?</p>
    </>
  );
};
